<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="套餐概况" name="package-overview"></el-tab-pane>
      <el-tab-pane label="套餐销售" name="package-sales"></el-tab-pane>
      <el-tab-pane label="套餐划扣" name="package-deduction"></el-tab-pane>
    </el-tabs>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 'package-overview'
    };
  },
  watch: {
    $route(e) {
      this.activeName = e.name;
    },
    activeName() {
      this.$router.push({
        name: this.activeName
      });
    }
  },
  activated() {
    this.activeName = this.$route.name;
  }
};
</script>
